import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const PageWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;
export const FlexWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
`;
export const ContentDiv = styled.div`
	height: ${props => props.id !== 3 && 'calc(100% - 43px)'};
	overflow: ${props => props.id !== 3 && 'auto'};
`;

export const NavDiv = styled.div`
	height: 40px;
	padding: 0 0 0 20px;
	button {
		height: 40px;
		font-size: 12px;
	}
`;

export const SettingsWrapper = styled.div`
	padding-right: 20px;
`;

export const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	margin-top: 15px;
	margin-left: 20px;
	font-size: 12px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};

	span {
		cursor: pointer;

		&:last-child {
			cursor: default;
			color: ${colors.grey8};
		}
	}
`;

export const ChartAndTableContainer = styled.div`
	margin-left: 20px;
	margin-right: 20px;
`;
